export default {"src":"/_next/static/media/blaize.962e23ba.svg","height":176,"width":133,"blurWidth":0,"blurHeight":0};